import { Link } from "react-router-dom";
import { useLang } from "@/lib/lang";
import { WHATSAPP_URL } from "@/lib/constants";
import { LogoLockup } from "@/components/dw/Logo";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer className="pt-16 pb-10" style={{ background: "var(--primary)", color: "var(--text-inverse)" }}>
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="[&_span]:!text-[var(--yellow)]">
              <LogoLockup size={64} />
            </div>
            <p className="mt-5 max-w-md text-lg font-semibold" style={{ color: "var(--yellow)" }}>{t.hero.tagline}</p>
            <p className="mt-2 max-w-md opacity-80">{t.footer.tagline}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <a href={WHATSAPP_URL} className="btn-primary" target="_blank" rel="noopener noreferrer">WhatsApp us</a>
              <a href="tel:+14375571041" className="btn-ghost" style={{ borderColor: "var(--yellow)", color: "var(--yellow)" }}>Call +1 437-557-1041</a>
            </div>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest opacity-60 font-bold">Navigate</div>
            <ul className="mt-4 space-y-2">
              <li><a href="#about" className="hover:underline">{t.nav.about}</a></li>
              <li><a href="#plans" className="hover:underline">{t.nav.plans}</a></li>
              <li><a href="#stories" className="hover:underline">{t.nav.stories}</a></li>
              <li><a href="#blog" className="hover:underline">{t.nav.blog}</a></li>
              <li><a href="#contact" className="hover:underline">{t.nav.contact}</a></li>
            </ul>
          </div>
          <div>
            <div className="text-xs uppercase tracking-widest opacity-60 font-bold">Business</div>
            <ul className="mt-4 space-y-2">
              <li>Chandigarh · Panchkula · Mohali · Delhi NCR</li>
              <li>Mumbai · Bangalore · Hyderabad · Online</li>
              <li>Canada · USA · UK · Australia · Middle East</li>
              <li><Link to="/admin/login" className="opacity-70 hover:opacity-100">{t.nav.admin}</Link></li>
            </ul>
          </div>
        </div>
        <div className="mt-12 pt-6 border-t opacity-60 text-sm flex justify-between" style={{ borderColor: "rgba(255,255,255,0.15)" }}>
          <div>© {new Date().getFullYear()} DietWalaa. {t.footer.rights}</div>
          <div>Led by Manthan Sharma</div>
        </div>
      </div>
    </footer>
  );
}
